// Js Enums
const tabs = { LEISURE: "leisure", STRICT: "strict", USER: "user" };

Object.freeze(tabs);

export default tabs;